import { OrderDto, UserDto } from "../models/dto";
import { getAttendeeUserEmail } from "./attendee-reserved-data.utils";

export const getUserEmail = (user?: { receiptsEmail?: string; email?: string }): string | undefined =>
	user?.receiptsEmail || user?.email;

export const getUserName = (user?: { fullName?: string; userName?: string }): string | undefined =>
	user?.fullName || user?.userName;

export const getUserPhoneNumber = (user?: { login?: string; phone?: string; phoneNumber?: string; }): string | undefined => user?.phoneNumber || user?.phone || user?.login;

export const fullNameToUsername = (fullName: string): string =>
	fullName?.replace(/\s/g, '_')?.replace(/[^\w]/g, '') || '';

export const getRecipientOfTicketEmail = (order?: OrderDto, userRecipient?: UserDto): string => {
	const userTicket = order?.tickets?.find(ticket => ticket.userId === userRecipient?.id) || order?.tickets?.[0];
	// get ticket email or fallback to purchaser email
	const recipientEmail = getAttendeeUserEmail(userTicket, order);

	return recipientEmail;
}

export const getUserHasProPlan = (user?: UserDto): boolean => !!user?.clientMetadata?.proPlan;
